<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-toolbar">
                    <div>
                        <h4 class="text-primary">Customer</h4>
                        <ol class="breadcrumb breadcrumb-card-header">
                            <li class="breadcrumb-item">
                                <a href="javascript:void(0);" @click="backParent">Customer</a>
                            </li>
                            <li class="breadcrumb-item active">
                                <span v-if="customer.id === null">New</span>
                                <span v-else>
                                    {{ customer.customer_no }}
                                </span>
                            </li>
                        </ol>
                        <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
                        <div class="dropdown-menu" aria-labelledby="printsales">
                          <a class="dropdown-item" href="javascript:void(0)" @click="setRating">Re-Rating</a>
                        </div>
                        <button type="button" @click="updateCustomer" class="btn btn-sm btn-soft-primary pull-left" v-show="customer.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
                        <button type="button" @click="createCustomer" class="btn btn-sm btn-soft-primary pull-left" v-show="customer.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-list">
            <div class="card-header">
                <div class="col-md-12">
                    <h5>
                        <span v-if="customer.id === null">New</span>
                        <span v-else>{{ customer.customer_no }} - {{ customer.name }}</span>
                    </h5>
                </div>
            </div>
            <div class="card-body">
                <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item">
                        <a href="#data" data-toggle="tab" aria-expanded="false" class="nav-link active">
                            Data
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#sales" data-toggle="tab" aria-expanded="true" class="nav-link">
                            Sales
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#sale-product" data-toggle="tab" aria-expanded="false" class="nav-link"> Sale by Product</a>
                    </li>
                    <li class="nav-item">
                        <a href="#payment" data-toggle="tab" aria-expanded="true" class="nav-link">
                            Payment
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#order" data-toggle="tab" aria-expanded="true" class="nav-link">
                            Order
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#services" data-toggle="tab" aria-expanded="true" class="nav-link">
                            Services
                        </a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" id="data">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="group_id" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                                    <div class="col-sm-9">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="customer.active" :disabled="authUser.permissions.customer_active === false">
                                            <label for="canBarcode" class="custom-control-label">Active</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="group_id" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                                    <div class="col-sm-9">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" id="rating_auto" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="customer.rating_auto" :disabled="authUser.permissions.customer_active === false">
                                            <label for="rating_auto" class="custom-control-label">Auto Rating</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="rating_id" class="col-sm-3 col-form-label text-left">Rating</label>
                                    <div class="col-sm-9">
                                      <select class="form-control" v-model="customer.rating_id" @change="ratingAuto" :disabled="authUser.permissions.customer_active === false">
                                        <option v-for="r in customerRatingList" :key="r.id" :value="r.id">{{ r.name }}</option>
                                      </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="term_due_id" class="col-sm-3 col-form-label text-left">Term Due</label>
                                    <div class="col-sm-9">
                                        <select class="form-control" v-model="customer.term_due_id">
                                            <option v-for="r in termDueList" :key="r.id" :value="r.id">{{ r.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="group_id" class="col-sm-3 col-form-label text-left">Group</label>
                                    <div class="col-sm-9">
                                        <div class="form-check form-check-inline" v-for="g in customerGroupList" :key="g.id">
                                            <input class="form-check-input" type="radio" :id="g.id" :value="g.id" v-model="customer.group_id">
                                            <label class="form-check-label" :for="g.id">{{ g.name }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.name" class="form-control" :disabled="customer.id"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="name" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                                    <div class="col-sm-9">
                                        <button type="button" class="btn btn-hard-primary btn-sm" data-toggle="modal" data-target="#modalCustomerChangeName" data-backdrop="static" data-keyboard="false">Change Name</button>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" v-model="customer.email"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.phone" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
                                    <div class="col-sm-9">
                                        <textarea rows="5" v-model="customer.address" class="form-control"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="state_id" class="col-sm-3 col-form-label text-left">State</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.state_id" class="form-control">
                                            <option v-for="s in stateList" :key="s.id" :value="s.id">{{ s.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="city_id" class="col-sm-3 col-form-label text-left">City</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.city_id" class="form-control">
                                            <option v-for="c in cityList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="area_id" class="col-sm-3 col-form-label text-left">Area</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.area_id" class="form-control">
                                            <option v-for="a in areaList" :key="a.id" :value="a.id">{{ a.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="identity_number" class="col-sm-3 col-form-label text-left">No. KTP</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.identity_number" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="vat" class="col-sm-3 col-form-label text-left">NPWP</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.vat" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="plafond_type" class="col-sm-3 col-form-label text-left">Plafond Type</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.plafond_type" class="form-control">
                                            <option value="omzet">Omzet</option>
                                            <option value="outstanding">Outstanding</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="plafond_amount" class="col-sm-3 col-form-label text-left">Plafond Amount</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.plafond_amount" class="form-control" v-money="money">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="vat" class="col-sm-3 col-form-label text-left">Notes</label>
                                    <div class="col-sm-9">
                                        <textarea v-model="customer.notes" class="form-control" rows="5"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="sales">
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-item mb-0 table-sm">
                                    <thead>
                                        <th>Status</th>
                                        <th>No. Sales</th>
                                        <th>Date</th>
                                        <th>Due Date</th>
                                        <th>Payment Date</th>
                                        <th>Age</th>
                                        <th class="text-right">Subtotal</th>
                                        <th class="text-right">Discount</th>
                                        <th class="text-right">Tax</th>
                                        <th class="text-right">Total</th>
                                        <th class="text-right">Total Payment</th>
                                        <th class="text-right">Outstanding</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="s in getSale" :key="s.id">
                                            <td>
                                                <span class="badge badge-success" v-if="s.status === 'Open'">{{ s.status }}</span>
                                                <span class="badge badge-warning" v-else-if="s.status === 'outstanding'">{{ s.status }}</span>
                                                <span class="badge badge-primary" v-else-if="s.status === 'approved'">{{ s.status }}</span>
                                                <span class="badge badge-warning" v-else-if="s.status === 'order'">{{ s.status }}</span>
                                                <span class="badge badge-danger" v-else>{{ s.status }}</span>
                                            </td>
                                            <td>
                                                <span style="color: blue; cursor: pointer;" @click="showSaleNo(s.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ s.sale_no }} </span>
                                            </td>
                                            <td>{{ s.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                            <td>
                                                <span class="badge badge-danger" v-if="s.status === 'overdue'">{{ s.sale_due_date | dateFormat('DD/MM/YYYY') }}</span>
                                                <span v-else>{{ s.sale_due_date | dateFormat('DD/MM/YYYY') }}</span>
                                            </td>
                                            <td>{{ s.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                            <td>{{ s.age }}</td>
                                            <td class="text-right">{{ s.subtotal | currency }}</td>
                                            <td class="text-right">{{ s.discount | currency }}</td>
                                            <td class="text-right">{{ s.tax | currency }}</td>
                                            <td class="text-right">{{ s.total | currency }}</td>
                                            <td class="text-right">{{ s.total_payment | currency }}</td>
                                            <td class="text-right">{{ s.outstanding | currency }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td><h5><b>Total:</b></h5></td>
                                            <td class="text-right"><b>{{ getTotalSales | currency }}</b></td>
                                            <td class="text-right"><b>{{ getTotalSalesPayment | currency }}</b></td>
                                            <td class="text-right"><b>{{ getTotalSalesOutstanding | currency }}</b></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="payment">
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-item mb-0 table-sm">
                                    <thead>
                                        <th>Sale No.</th>
                                        <th>Payment No.</th>
                                        <th>Group No.</th>
                                        <th>Date</th>
                                        <th>Notes</th>
                                        <th class="text-right">Total</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="p in getPayment" :key="p.id">
                                            <td>
                                                <span style="color: blue; cursor: pointer;" @click="showSaleNo(p.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ p.sale_no }} </span>
                                            </td>
                                            <td>
                                                <span><b>{{ p.payment_no }}</b></span>
                                            </td>
                                            <td>
                                                <span style="color: blue; cursor: pointer;" @click="showPaymentNo(p.group_no)" data-toggle="modal" data-target="#modalPaymentGroup" data-backdrop="static" data-keyboard="false">{{ p.group_no }} </span>
                                            </td>
                                            <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                            <td>{{ p.notes }}</td>
                                            <td class="text-right">{{ p.price | currency }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <h5><b>Total:</b></h5>
                                            </td>
                                            <td class="text-right">
                                                <h5><b>{{ getTotalPayment | currency }}</b></h5>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="services">
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-item mb-0 table-sm">
                                    <thead>
                                        <th>Status</th>
                                        <th>No. Workshop</th>
                                        <th>Date</th>
                                        <th>Branch</th>
                                        <th class="text-right">Total</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="w in getWorkshop" :key="w.id">
                                            <td>{{ w.status }}</td>
                                            <td>
                                                <span @click="toWorkshop(w.id)"><b>{{ w.workshop_no }}</b></span>
                                            </td>
                                            <td>{{ w.date_in }}</td>
                                            <td>{{ w.branch_no }}</td>
                                            <td class="text-right">{{ w.total | currency }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <h5><b>Total:</b></h5>
                                            </td>
                                            <td class="text-right">
                                                <h5><b>{{ getTotalWorkshop | currency }}</b></h5>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="order">
                        <CustomerOrderList :customer="customer" />
                    </div>
                    <div class="tab-pane" id="sale-product">
                        <CustomerSaleProductList :customer="customer" />
                    </div>

                </div>
            </div>
            <div class="card-footer">
                <!-- <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
                <button type="button" @click="updateCustomer" class="btn btn-sm btn-primary pull-right" v-show="customer.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
                <button type="button" @click="createCustomer" class="btn btn-sm btn-primary pull-right" v-show="customer.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button> -->
            </div>
        </div>
        <SaleModal />
        <PaymentModal />
        <CustomerChangeNameModal :customer="customer" @changeName="changeName" />
        <!-- <pre>{{ customer }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { customerUrl, getHeader } from '@/config'
import CustomerOrderList from '@/components/customer/CustomerOrderList.vue'
import CustomerSaleProductList from '@/components/customer/CustomerSaleProductList.vue'
import SaleModal from '@/components/sales/SaleModal.vue'
import PaymentModal from '@/components/payment/PaymentGroupModal.vue'
import CustomerChangeNameModal from '@/components/customer/CustomerChangeNameModal.vue'

export default {
  name: 'CustomerForm',
  props: ['customer'],
  components: {
    SaleModal,
    PaymentModal,
    CustomerOrderList,
    CustomerSaleProductList,
    CustomerChangeNameModal
  },
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      cityList: state => state.city.cityList,
      stateList: state => state.state.stateList,
      areaList: state => state.area.areaList,
      customerGroupList: state => state.customers.customerGroupList,
      customerRatingList: state => state.customers.customerRatingList,
      termDueList: state => state.termduedates.termDueList,
      authUser: state => state.users.authUser
    }),
    getTotalWorkshop: function () {
      var sum = 0
      var array = this.customer.workshop
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    getTotalSales: function () {
      var sum = 0
      var array = this.customer.sale
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    getTotalSalesPayment: function () {
      var sum = 0
      var array = this.customer.sale
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_payment)
      }
      return sum
    },
    getTotalSalesOutstanding: function () {
      var sum = 0
      var array = this.customer.sale
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    getTotalPayment: function () {
      var sum = 0
      var array = this.customer.payment
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price)
      }
      return sum
    },
    getSale: function () {
      return this.customer.sale.filter(d => d.id !== null)
    },
    getPayment: function () {
      return this.customer.payment.filter(d => d.id !== null)
    },
    getWorkshop: function () {
      return this.customer.workshop
    }
  },
  methods: {
    async ratingAuto () {
      if (this.customer.rating_id === 'vip') {
        this.customer.rating_auto = false
      }
    },
    async setRating () {
      var check = false
      await this.$swal.fire({
        title: 'Are you sure to Re-Rating Customer data?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
      }).then((result) => {
        if (result.value) {
          check = true
        } else {
          check = false
        }
      })
      if (check === true) {
        await axios.post(customerUrl + '/sales-outstanding-expire', { customer_no: this.customer.customer_no }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.rating)
            this.customer.rating_id = response.data.rating_id
            this.$swal('Customer', 'Success set Re-Rating Customer', 'success')
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Customer', error.response.data.message, 'error')
            throw error
          })
      }
    },
    async changeName (value) {
      var obj = {
        customer_no: this.customer.customer_no,
        name: this.customer.name,
        replace_name: value.replace_name
      }
      await axios.post(customerUrl + '/change-name', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Customer', response.data.message, 'success')
          this.customer.name = response.data.data.name
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Customer', error.response.data.message, 'error')
          throw error
        })
    },
    toWorkshop: function (id) {
      this.$router.push({ name: 'workshop', query: { workshop: id } })
    },
    toSales: function (id) {
      this.$router.push({ name: 'sales', query: { sales: id } })
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    updateCustomer () {
      var body = {
        id: this.customer.id,
        name: this.customer.name,
        customer_no: this.customer.customer_no,
        group_id: this.customer.group_id,
        email: this.customer.email,
        phone: this.customer.phone,
        address: this.customer.address,
        city_id: this.customer.city_id,
        state_id: this.customer.state_id,
        identity_number: this.customer.identity_number,
        vat: this.customer.vat,
        birthday: this.customer.birthday,
        birthplace: this.customer.birthplace,
        twitter: this.customer.twitter,
        facebook: this.customer.facebook,
        instagram: this.customer.instagram,
        card_id: this.customer.card_id,
        level_id: this.customer.level_id,
        company_no: this.customer.company_no,
        area_id: this.customer.area_id,
        rating_id: this.customer.rating_id,
        term_due_id: this.customer.term_due_id,
        active: this.customer.active,
        notes: this.customer.notes,
        rating_auto: this.customer.rating_auto,
        plafond_type: this.customer.plafond_type,
        plafond_amount: this.customer.plafond_amount.replace(/\./g, '')
      }
      axios.put(customerUrl + '/' + this.customer.id, body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Customer',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '',
            'error'
          )
        })
    },
    createCustomer () {
      var body = {
        id: this.customer.id,
        name: this.customer.name,
        customer_no: this.customer.customer_no,
        group_id: this.customer.group_id,
        email: this.customer.email,
        phone: this.customer.phone,
        address: this.customer.address,
        city_id: this.customer.city_id,
        state_id: this.customer.state_id,
        identity_number: this.customer.identity_number,
        vat: this.customer.vat,
        birthday: this.customer.birthday,
        birthplace: this.customer.birthplace,
        twitter: this.customer.twitter,
        facebook: this.customer.facebook,
        instagram: this.customer.instagram,
        card_id: this.customer.card_id,
        level_id: this.customer.level_id,
        company_no: this.customer.company_no,
        area_id: this.customer.area_id,
        rating_id: this.customer.rating_id,
        term_due_id: this.customer.term_due_id,
        active: this.customer.active,
        notes: this.customer.notes,
        rating_auto: this.customer.rating_auto,
        plafond_type: this.customer.plafond_type,
        plafond_amount: this.customer.plafond_amount.replace(/\./g, '')
      }
      axios.post(customerUrl, body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Customer', error.response.data.message, 'error')
          throw error
        })
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    showPaymentNo (no) {
      var payload = {
        group_no: no
      }
      this.$store.commit('SET_PAYMENT_BY_NO', payload)
      this.$store.dispatch('getPaymentByNo', payload)
    }
  }
}
</script>
